import React from 'react';
import _ from 'lodash';
import URI from 'urijs';
import cheerio from 'cheerio';
import textVersion from 'textversionjs';

const MOBILE_DESCRIPTION = 'Click here to see description';
function addStylesheets(stylesheets, shouldRenderMobileView = null, simpleTextEnforcement = false) {
  return _.map(stylesheets, (stylesheet) => {
    const uri = new URI(stylesheet);
    if (shouldRenderMobileView) {
      uri.setSearch('mobileOptimized', true);
    }
    if (simpleTextEnforcement) {
      uri.setSearch('ste', true);
    }
    const uriString = uri.toString();
    return `<link rel="stylesheet" href="${uriString}" />`;
  });
}

function wrapWithStyleTag(rules) {
  return `<style>${rules}</style>`;
}

function getMetaTags(shouldRenderMobileView, tagsToAdd) {
  const metaTags = [];
  _.forEach(tagsToAdd, (value, key) => {
    if (!_.isNil(value)) {
      metaTags.push(`<meta name="${key}" content="${value}" />`);
    }
  });
  if (shouldRenderMobileView) {
    metaTags.push(`<meta name="viewport" content="width=device-width, initial-scale=1, user-scalable=no" />`);
  }
  return metaTags.join('');
}

function addMobileDescription(description = MOBILE_DESCRIPTION) {
  description = textVersion(description).replace(/(?:\r\n|\r|\n)/g, ' ');
  return <div key="mobile-description" vocab="https://schema.org/" typeof="Product" id="mobile-description" style={{display: 'none'}}><span property="description">{description}</span></div>;
}

function getResponsiveLayoutStyles(desktopRendererId, mobileRendererId, mobileProps) {
  const desktopRules = [];
  const mobileRules = [];
  const mobileBodyRules = [];

  // desktop rules
  desktopRules.push(`#${mobileRendererId} { display: none; }`); // hide mobile view

  // mobile rules
  mobileRules.push(`#${desktopRendererId} { display: none; }`); // hide desktop view
  mobileRules.push(`#${mobileRendererId} { display: block; }`); // show mobile view

  if (mobileProps.backgroundColor) {
    mobileBodyRules.push(`background-color: ${mobileProps.backgroundColor};`);
  }

  if (mobileProps.backgroundImage) {
    mobileBodyRules.push(`background-image: ${mobileProps.backgroundImage};`);
  }

  if (mobileBodyRules.length) {
    mobileRules.push(`body { ${mobileBodyRules.join('')}`);
  }

  return desktopRules.join('') + '@media screen and (max-device-width: 480px), screen and (max-width: 480px) {' + mobileRules.join('') + '}';
}

function removeStyles(publishCode, templateCSSUrl) {
  const CSS = [];
  const $ = cheerio.load(publishCode);
  const styles = $('style');
  const cssUrl = templateCSSUrl ? templateCSSUrl : 'CL_CSS_URL_PLACEHOLDER';
  styles.each((index, element) => {
    CSS.push($(element).html());
  });
  styles.remove();
  $('[id][style]').each((index, element) => {
    if ($(element).data('exclude-css-removal') !== true) {
      const elementId = $(element).attr('id');
      const elementStyle = $(element).attr('style');
      CSS.push(`
        #${elementId} {
          ${elementStyle}
        }
      `);
      $(element).attr('style', null);
    }
  });
  $('head').append(`<link rel="stylesheet" href="${cssUrl}">`);
  return {publishCode: $.html(), templateCSS: CSS.join('').replace(/\s{2,}/g, '')};
}

export {
  addStylesheets,
  getMetaTags,
  addMobileDescription,
  getResponsiveLayoutStyles,
  removeStyles,
};
